import { defineMutators } from '@rocicorp/zero';
import { trackMutators } from './track/mutators';

export const mutators = defineMutators({
  track: trackMutators,
});

export {
  zCreateTrackArgs,
  type CreateTrackArgs,
  zDeleteTrackArgs,
  type DeleteTrackArgs,
  zArchiveTrackArgs,
  type ArchiveTrackArgs,
  type TrackMutatorCtx,
} from './track/mutators';
